export default class PersonPhoneDomainService {
    static fromJSON(json) {
        return Object.assign(Object.assign({}, json), { verifiedDate: json.verifiedDate && new Date(json.verifiedDate) });
    }
    static formatPhoneNumberForTelLink(phoneNumber) {
        if (!phoneNumber) {
            return "";
        }
        // This makes a lot of assumptions about the phone numbers we accept, and is an extremely crude way to
        // do this. If we wanted to go with something more robust in the future, we might consider
        // https://github.com/halt-hammerzeit/libphonenumber-js
        return phoneNumber.replace(/[^\d]/g, "");
    }
}
